<template>
  <div :key="refreshKey">
    <!-- 標題 begin -->
    <div class="container-fluid py-4">
      <div class="row">
        <div class="col-6">
          <h6 class="m-0 text-mcf-color">{{ title }}</h6>
        </div>
        <div class="col-6">
        </div>
      </div>
    </div>
    <!-- 標題 end -->
    <!-- tab begin -->
    <b-tabs class="te-tabs-mcf font-size-md position-relative px-3" nav-class="" justified>
      <template v-for="tab in tabs">
        <b-tab v-if="tab.isShow" :key="tab.type" :active="tab.type === currentTab" @click="onTabClick(tab.type)">
          <template v-slot:title>
            <div class="d-flex flex-column justify-content-center align-items-center text-mcf-color">
              <span>{{ tab.title }}</span>
              <h5 class="font-weight-normal m-0">{{ tab.orderQuantity | counter(10) }}</h5>
              <span class="active-bar bg-customize"></span>
            </div>
          </template>
        </b-tab>
      </template>
    </b-tabs>
    <!-- tab end -->
    <ListContainer :ref="'listcontainer'" itemKey="orderId" :fetch="fetch" :filter="filter" :emptyHint="emptyHint" :spinner="spinnerStyle" @initialized="onListInitialized">
      <!-- OrderList begin -->
      <template v-slot:list-item="{ item }">
        <div class="m-3 bg-white border border-light rounded-md overflow-auto">
          <div class="d-flex align-items-center justify-content-between bg-gray100" @click="onOrderToggle(item)">
            <div class="p-3 font-size-md flex-grow-1">{{ $t('order.orderId') }} {{ item.orderId }}</div>
            <OrderButtonGroup
              :ref="`orderButtonGroup${item.orderId}`"
              :order="item"
              :buttonConfigBase="buttonConfigBase"
              @buttonEvent="buttonTriggerEvent"/>
            <div>
              <a class="px-2 text-gray600" href="javascript:void(0);">
                <span class="material-icons">
                  <template v-if="item.isCollapsed">keyboard_arrow_up</template>
                  <template v-else>keyboard_arrow_down</template>
                </span>
              </a>
            </div>
          </div>
          <b-collapse :id="item.orderId">
            <template v-if="item.isCollapsed">
              <div class="d-flex p-3">
                <OrderDetail class="mt-n4 mr-3 w-100" :order="item" />
                <div class="border border-light p-3 rounded">
                  <OrderTimeline class="timeline flex-column-reverse" :order="item" />
                </div>
              </div>
            </template>
          </b-collapse>
        </div>
      </template>
      <!-- OrderList end -->
    </ListContainer>
    <McfReturnRequestPC
      v-if="isOpen"
      :isPageOpen.sync="isOpen"
      :pageType.sync="pageType"
      :order="processingOrder"/>
  </div>
</template>

<script>
import { forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';
import OrderDetail from '@/components/order/OrderDetail.vue';
import OrderTimeline from '@/components/order/OrderTimeline.vue';
import OrderButtonGroup from '@/components/order/OrderButtonGroup.vue';
import ListContainer from '@/components/ListContainer.vue';
import McfReturnRequestPC from '@/components/return/McfReturnRequestPC.vue';
import pdiService from '@/services/pdiService';
import pageSettingGetter from '@/utils/pageSettingGetter';
import commonTool from '../../utils/commonTool';

export default {
  components: {
    OrderDetail,
    OrderTimeline,
    OrderButtonGroup,
    ListContainer,
    McfReturnRequestPC,
  },
  data() {
    return {
      title: '',
      // 頁籤資料
      tabs: [
        {
          type: 'processing', functionType: 'OrderStatusProcessing', title: this.$t('order.progress.processing'), orderQuantity: 0, isShow: false,
        },
        {
          type: 'unreceived', functionType: 'OrderStatusUnreceived', title: this.$t('order.progress.unclaimed'), orderQuantity: 0, isShow: false,
        },
        {
          type: 'completed', functionType: 'OrderStatusCompleted', title: this.$t('order.progress.completed'), orderQuantity: 0, isShow: false,
        },
        {
          type: 'cancelled', functionType: 'OrderStatusCancel', title: this.$t('order.progress.canceled'), orderQuantity: 0, isShow: false,
        },
      ],
      // 目前頁籤
      currentTab: 'processing',
      // 各狀態訂單按鈕基礎設定
      buttonConfigBase: {},
      // 空白頁設定
      emptyHint: {},
      // 讀取spinner樣式
      spinnerStyle: '',
      filter: {
        status: undefined,
        source: 'TelexpressEC',
      },
      // 是否顯示退款或是取消頁
      isOpen: false,
      // 是取消或是退貨
      pageType: '',
      // 取消或是退貨的訂單資訊
      processingOrder: {
        items: [],
        hasLoaded: true,
      },
      refreshKey: 0,
    };
  },
  created() {
    const vm = this;
    // 訂單篩選狀態，依照預設頁籤
    vm.filter.status = vm.currentTab;
    vm.$store.commit('set', { name: 'currentOrderTab', value: vm.currentTab });

    // 取得頁面 style
    const getHomePageSetting = vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        vm.spinnerStyle = setting.layoutType === '0' ? 'light' : 'secondary';
        return setting;
      });

    // 取得頁面設定
    const getShoppingHistorySetting = vm.$store.dispatch('getPageSetting', 'ShoppingHistory')
      .then((setting) => {
        // title
        const title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        vm.title = title;

        // order tab
        vm.tabs.forEach((x) => {
          x.isShow = pageSettingGetter.getFunction(setting, x.functionType).isShow;
        });

        // 訂單各狀態按鈕設定
        const orderButtonSetting = {
          processing: [{ type: 'orderCancel', dataType: 'StatusProcessingOrderReturn' }, { type: 'contactServiceCenter', dataType: 'StatusProcessingContactServiceCenter' }],
          unreceived: [{ type: 'orderReturn', dataType: 'StatusUnreceivedOrderReturn' }, { type: 'contactServiceCenter', dataType: 'StatusUnreceivedContactServiceCenter' }],
          completed: [{ type: 'orderReturn', dataType: 'StatusCompletedOrderReturn' }, { type: 'contactServiceCenter', dataType: 'StatusCompletedContactServiceCenter' }, { type: 'buyAgain', dataType: 'StatusCompletedBuyAgain' }],
          cancelled: [{ type: 'contactServiceCenter', dataType: 'StatusCancelContactServiceCenter' }, { type: 'buyAgain', dataType: 'StatusCancelBuyAgain' }],
        };

        // 訂單按鈕資料取得
        Object.keys(orderButtonSetting).forEach((x) => {
          orderButtonSetting[x] = orderButtonSetting[x].reduce((accu, current) => {
            const data = pageSettingGetter.getFunction(setting, current.dataType);
            if (data && data.isShow) {
              current.order = data.order;
              current.text = pageSettingGetter.getFunctionWording(setting, current.dataType);
              accu.push(current);
            }
            return accu;
          }, []);
          // 按鈕排序
          orderButtonSetting[x].sort((a, b) => a.order - b.order);
        });

        vm.buttonConfigBase = orderButtonSetting;
        return setting;
      });

    Promise.all([getHomePageSetting, getShoppingHistorySetting])
      .then((res) => {
        // 空白頁設定
        vm.emptyHint.originDesc = pageSettingGetter.getFunctionWording(res[1], 'BlankPageWording');
        vm.emptyHint.desc = vm.emptyHint.originDesc.replace('{orderStatus}', vm.tabs.find((x) => x.type === vm.currentTab).title);
        vm.emptyHint.img = pageSettingGetter.getFunction(res[1], 'BlankPagePic').picUrl;
        if (pageSettingGetter.getFunction(res[1], 'BlankPageGoShoppingMall').isShow) {
          vm.emptyHint.button = {
            text: pageSettingGetter.getFunctionWording(res[1], 'BlankPageGoShoppingMall'),
            onClick: () => {
              vm.$loading(commonTool.getPersonalStoreUrl().pipe(
                tap((storeUrl) => {
                  window.location.assign(storeUrl);
                }),
              ));
            },
          };
        }
      });
  },
  provide() {
    return {
      updateOrderButton: this.updateButton,
    };
  },
  methods: {
    // 按鈕觸發事件
    buttonTriggerEvent(type, order) {
      switch (type) {
        case 'return':
          this.openReturnOrderPage(order, 'return');
          break;
        case 'cancel':
          // 打開取消頁
          this.openCancelOrderPage(order, 'cancel');
          break;
        default:
          break;
      }
    },
    // 打開退貨頁
    openReturnOrderPage(order, type) {
      const vm = this;
      vm.isOpen = true;
      vm.pageType = type;
      vm.processingOrder = order;
      if (!order.isCollapsed) {
        vm.onOrderToggle(order);
      }
    },
    // 打開取消頁
    openCancelOrderPage(order, type) {
      const vm = this;
      vm.isOpen = true;
      vm.pageType = type;
      vm.processingOrder = order;
      if (!order.isCollapsed) {
        vm.onOrderToggle(order);
      }
    },
    // 頁籤點擊
    onTabClick(type) {
      const vm = this;
      vm.currentTab = type;
      vm.filter.status = type;
      vm.$store.commit('set', { name: 'currentOrderTab', value: vm.currentTab });

      // 設定空白頁文案
      vm.emptyHint.desc = vm.emptyHint.originDesc.replace('{orderStatus}', vm.tabs.find((x) => x.type === vm.currentTab).title);
    },
    // 取得資料 observable
    fetch(pagination, filterlist) {
      const vm = this;
      const payload = { pagination, ...filterlist };
      return forkJoin({ list: vm.updateOrderList(payload), updateTabs: vm.updateTabs(filterlist.source) });
    },
    // 列表初始化完成
    onListInitialized(data) {
      if (data[0]) {
        this.onOrderToggle(data[0]);
      }
    },
    // 訂單展開/縮合
    onOrderToggle(order) {
      const vm = this;
      order.isCollapsed = !order.isCollapsed;
      // 判斷是否已經載入商品資料
      if (order.isCollapsed && !order.hasLoaded) {
        const body = {
          companyId: vm.$store.state.companyId,
          productInfos: order.items.map((x) => ({
            productCode: x.productCode,
            subProductCode: x.subProductCode,
            productVer: x.productVer,
          })),
        };
        vm.$subscribeTo(pdiService.getProducts(body), (res) => {
          if (!res.response.data) return;
          order.items.forEach((item) => {
            const current = res.response.data.find((x) => x.productID === item.productId && x.productVer === item.productVer && x.spec.subProductCode === item.subProductCode);
            item.sPicture = current.sPicture;
            item.productName_CH = current.productName_CH;
            item.spec = current.spec;
          });

          order.hasLoaded = true;
        });
      }

      // toggle collapse
      vm.$root.$emit('bv::toggle::collapse', order.orderId);
    },
    // 更新頁籤資料
    updateTabs(souce) {
      const vm = this;
      return vm.$store.dispatch('getMemberOrderCount', souce).then((res) => {
        vm.tabs.forEach((tab) => { tab.orderQuantity = res.response.data[tab.type]; });
      });
    },
    // 更新訂單列表
    updateOrderList(payload) {
      const vm = this;
      return vm.$store.dispatch('getMemberOrder', payload).then((res) => {
        if (res.response && res.response.data) {
          return res.response.data.map((x) => ({
            id: x.orderID,
            orderId: x.eRPOrderID,
            saleTime: x.saleTime,
            currency: x.currency,
            totalPrice: x.amountIncF,
            couponDiscount: x.couponDiscount,
            discount: x.totalDiscount,
            pointDiscount: x.pointDiscount,
            shippingFee: x.shippingFee,
            payment: x.payment,
            paymentTime: x.paymentTime,
            status: x.status,
            paymentStatus: x.paymentStatus,
            deliveryStatus: x.deliveryStatus,
            deliveryMethodId: x.deliveryMethodID,
            memberName: x.memberName,
            memberMobile: x.memberMobile,
            city: x.city,
            district: x.district,
            address: x.address,
            deptName: x.deptName,
            paymentTypeName: x.paymentTypeName,
            logisticsProviderId: x.logisticsProviderID,
            logisticsNo: x.logisticsNo,
            invoiceTypeName: x.invoiceTypeName,
            isTEECOrder: x.isTEECOrder,
            shippingMethodName: x.shippingMethodName,
            isReturnRequest: x.isReturnRequest,
            isCancelRequest: x.isCancelRequest,
            items: x.productInfo.map((item) => ({
              productCode: item.productCode,
              subProductCode: item.subProductCode,
              productVer: item.productVer,
              productId: item.productID,
              price: item.price,
              subAmount: item.subAmount,
              subDiscount: item.subtotalDiscount,
              qty: item.qty,
              subtotalTax: item.subtotalTax,
              subtotal: item.subtotalPrice,
            })),
            events: x.eventInfo,
            isCollapsed: false,
            hasLoaded: false,
            zipCode: x.zipCode,
            country: x.country,
            province: x.province,
            paymentType: x.paymentType,
            eRPOrderID: x.eRPOrderID,
          }));
        }
        return [];
      });
    },
    // 更改按鈕狀態以及文案
    updateButton(event) {
      this.$refs[`orderButtonGroup${event.orderId}`].updateButton(event.buttonType, event.buttonInfo);
    },
  },
};
</script>
